import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import {AmdocsEventBusService } from 'amdocs-core-package';
import { CONSTANTS } from '../../../constants';
import * as AmdocsContentConstants from '../../../content.constants';
import { AMDOCS_CONSTANTS, CHAT_CONSTANTS } from '../../../feature/ping/ping.constants';
import { PwaService } from 'src/app/core/pwa.service';
@Component({
  selector: 'app-version-alert',
  templateUrl: './version-update.component.html',
  styleUrls: ['./version-update.component.scss']
})
export class VersionUpdateComponent {

  public showVersionUpdate = false;
  public amdocsContentConstant: any = AmdocsContentConstants?.default;
  private timerInterval: any;
  private secondsLeft: number = AMDOCS_CONSTANTS.RELOAD_TIME;
  private timerActive: boolean = true;
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  constructor(private eventBus: AmdocsEventBusService, private readonly updates: SwUpdate, private pwaService: PwaService) {
    this.eventBus.on(CONSTANTS.EVENTS.SHOW_NEW_VERSION_ALERT, () => {
      this.startTimer();
      this.showVersionUpdate = true;
    }, true);
  }
startTimer() {
  // this.updateTimerDisplay();
  this.timerActive = true; // Ensure timerActive is true when starting
  this.timerInterval = setInterval(() => {
    if (this.secondsLeft > 0) {
      this.secondsLeft--;
      // this.updateTimerDisplay();
      this.cdr.markForCheck();
    } else {

    this.stopTimer();         // Stop timer first
      if (!this.timerActive) {   // Only reload if timer wasn't stopped by user
        this.hardReload();
      }
    }
  }, 1000);
}

    updateTimerDisplay() {
    const mins = Math.floor(this.secondsLeft / 60).toString().padStart(2, '0');
    const secs = (this.secondsLeft % 60).toString().padStart(2, '0');
    // this.timerDisplay = `${mins}:${secs}`;
  }

  hardReload() {

      if (this.pwaService?.clearCachesAndReload) {
      this.pwaService?.clearCachesAndReload(true);
      return;
    }
  localStorage.setItem('cleanUrl', 'true');
  window.location.href = window.location.pathname + '?reload=' + new Date().getTime();
}

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
    this.timerActive = false;
  }

  public reload(): void  {
      this.hardReload();
      this.stopTimer();
  }

}
